import type { Content } from '@types'
import axios from 'axios'
import FormData from 'form-data'

import env from '../environments'

export interface AddContentParams {
	brainId: string;
	url: string;
	notificationId?: string | undefined;
	title?: string | undefined;
	html?: string | undefined;
	accessToken?: string | undefined;
}

type UpdateContentParams = Omit<AddContentParams, 'brainId'> & {id: string}

export async function addContent({ brainId, url, title, html, accessToken, notificationId }: AddContentParams) {
	let headers

	if (accessToken) {
		headers = {
		// eslint-disable-next-line @typescript-eslint/naming-convention
			Authorization: 'Bearer ' + accessToken
		}
	}

	const result = await axios.post(env.contentApiUrl + '/contents', {
		brainId,
		url,
		title,
		html,
		notificationId
	}, {
		headers
	})

	return result.data as Content
}

export async function uploadContent(brainId: string, file: Blob, notificationId: string, password?: string | undefined) {
	const formData = new FormData()

	formData.append('file', file)
	formData.append('size', file.size)
	formData.append('brainId', brainId)
	formData.append('notificationId', notificationId)
	if (password) {
		formData.append('password', password)
	}

	const result = await axios.post(`${env.contentApiUrl}/contents/file`, formData, {
		headers: {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			'Content-Type': 'multipart/form-data'
		}
	})

	return result.data as Content
}

export async function updateContent({ id, url, title, html, accessToken }: UpdateContentParams) {
	let headers

	if (accessToken) {
		headers = {
		// eslint-disable-next-line @typescript-eslint/naming-convention
			Authorization: 'Bearer ' + accessToken
		}
	}

	const result = await axios.put(env.contentApiUrl + '/contents/' + id, {
		url,
		title,
		html
	}, {
		headers
	})

	return result.data as Content
}

export async function getFilePDF(id: string | undefined) {
	if (!id) {
		throw new Error('No ID provided')
	}

	return axios.get(`${env.contentApiUrl}/contents/file-pdf/${id}`, {
		responseType: 'blob'
	})
}

export async function exportFile(html: string, format: 'pdf' | 'docx' | 'xlsx', title: string) {
	return axios.post(`${env.contentApiUrl}/contents/convert-html/${format}`, {
		html,
		title
	}, {
		responseType: 'blob'
	})
}

export async function exportArtifact(artifactId: string, format: 'xlsx' | 'docx') {
	return axios.get(`${env.contentApiUrl}/contents/download-artifact/${artifactId}/${format}`, {
		responseType: 'blob'
	})
}
